import { CinchChargeRequestFormValues } from './types'
import { readFromEnv } from '@cinch-nx/environments'
import axios from 'axios'

const cinchChargeCardRequestService = axios.create({
  baseURL: readFromEnv('CINCH_CHARGE_CARD_REQUEST_URL'),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': readFromEnv('CINCH_CHARGE_CARD_REQUEST_API_KEY'),
  },
})

export const submitCinchChargeCardRequest = async (
  data: CinchChargeRequestFormValues,
) =>
  await cinchChargeCardRequestService.request<unknown>({
    url: `/cinch-charge-card-request`,
    data: data,
    method: 'POST',
  })
